'use strict';

const _ = require('underscore');
const i18n = require('i18next');
const Backbone = require('backbone');
const Mn = require('backbone.marionette');
const ActionStateService = require('process/app/service/action/state');
const Template = require('process/ui/template/action/state.hbs');
const ProceedStateTemplate = require('process/ui/template/action/proceed-state.hbs');
const ProcessPermission = require('process/domain/entity/permission');

const ProceedableState = Mn.View.extend({
    tagName: 'span',
    template: ProceedStateTemplate,
    triggers: {
        'click :not(.disabled)': 'proceed:state'
    },

    onRender: function() {
        if(this.getOption('disableFinalState') && this.model.isFinal()) {
            this.$('.btn').addClass('disabled');
            this.$('[data-toggle="tooltip"]').tooltip({
                title: i18n.t('process:states.noFinalizeParentAction')
            });
        }
    }
});

const ProceedableStateList = Mn.CollectionView.extend({
    tagName: 'span',
    childView: ProceedableState,
    childViewTriggers: {
        'proceed:state': 'proceed:state'
    },
    childViewOptions: function() {
        return {
            disableFinalState: this.getOption('disableFinalState')
        }
    }
});

module.exports = Mn.View.extend({
    template: Template,
    modelEvents: {
        change: 'render'
    },
    regions: {
        proceedableStateList: '.proceedable-state-list'
    },
    childViewEvents: {
        'proceed:state': 'proceed'
    },

    templateContext: function() {
        return {
            isEditable: this.isEditable(),
            state: this.model.getCurrentState().toJSON()
        }
    },

    onRender: function() {
        if(this.isEditable()) {
            this.model.getChildren()
                .then(children => {
                    const disableFinalState = !children.chain()
                        .map(c => c.getCurrentState())
                        .map(s => s.isFinal() || s.isTerminated())
                        .all()
                        .value();

                    this.showChildView('proceedableStateList', new ProceedableStateList({
                        collection: new Backbone.Collection(this.model.getProceedableStates()),
                        disableFinalState: disableFinalState
                    }));
                });
        }
    },

    isEditable: function() {
        const context = this.getOption('context');
        return context.getProjectRole().getPermission(
            ProcessPermission.ActionEditPermission
        ).isPermitted(context);
    },

    proceed: function(child) {
        const nextState = child.model;
        (new ActionStateService(this.model, nextState)).proceed();
    }
});



// WEBPACK FOOTER //
// ./process/ui/view/action/state.js